import React, { ReactNode } from "react";
import { Grid } from "@payping/web-components";

interface Props {
  mobile: ReactNode;
  desktop: ReactNode;
}
export const DetectMobileView: React.FC<Props> = (props) => {
  const { desktop, mobile } = props;
  const { lg } = Grid.useBreakpoint();

  return lg ? desktop : mobile;
};
